





































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import ElTableDraggable from 'element-ui-el-table-draggable';
import { UserTypes } from '@/enums/userTypes';
import moment from 'moment';
import Axios from 'axios';
import { CreditcardSettingResponse } from '@/models/creditcardSettingResponse';
import { CreditcardResponse, Creditcard } from '@/models/creditcardResponse';
import { ElForm } from 'node_modules/element-ui/types/form';
import DialogWrapper from '@/components/dialogWrapper.vue';

interface CreditcardEdit extends Creditcard {
  isEdit: boolean;
  securitycode: string;
  token: string | null;
}

@Component({
  components: {
    ElTableDraggable,
  }
})
export default class extends AvaivaledVue {
  private get studentId(): string { return this.$route.params.studentId; }
  private get student() { return this.$store.state.student.selectedStudent; }

  private tokenKey: string = '';
  private creditcard: Creditcard | null = null;
  private loading: boolean = true;

  private formRule = {
    number: [
      { required: true, message: 'カード番号を入力してください' },
      { pattern: '^\\d{14,16}$', trigger: 'blur', message: '半角数字14～16桁で入力してください' },
    ],
    expire: [
      { validator: this.validateExpire, trigger: 'blur' },
    ],
    holdername: [
      { required: true, message: 'カード名義人を入力してください' },
      { pattern: '^[A-Z]+\\s[A-Z]+$', trigger: 'blur', message: '半角大文字で入力してください' },
    ],
    securitycode: [
      { required: true, message: 'セキュリティコードを入力してください' },
      { pattern: '^\\d{3,4}$', trigger: 'blur', message: '2桁で入力してください' },
    ],
  };

  private validateExpire(rule: any, value: string, callback: any) {
    const dialogWrapper = this.$refs.cardEdit as DialogWrapper;
    const form = dialogWrapper.form as CreditcardEdit;
    if (/^\d{2}$/.test(form.expireMonth) && /^\d{2}$/.test(form.expireYear)) {
      callback();
    } else {
      callback(new Error('半角数字2桁で入力してください'));
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isStudent(): boolean {
    return this.userRole === UserTypes.Student;
  }

  get creditcardApiUrl(): string {
    return this.isStudent ? `/api/creditcard` : `/api/creditcard/${this.studentId}`;
  }

  private onValidate(propName: string) {
    const form = this.$refs.form as ElForm;
    form.validateField(propName, () => {
      //
    });
  }

  private async created() {
    this.loading = true;

    const resSetting = await Axios.get<CreditcardSettingResponse>('/api/bill-settings/creditcard');
    if (!resSetting.data.enabled) {
      this.loading = false;
      this.$router.push({ name: 'Top' });
      return;
    }

    this.tokenKey = resSetting.data.tokenKey;

    this.loadData();
  }

  private async mounted() {
    while (!(this as any).creditcardTokenUrl) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    const creditcardTokenUrl = (this as any).creditcardTokenUrl;
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', creditcardTokenUrl);
    document.head.appendChild(recaptchaScript);
  }

  private async loadData() {
    this.loading = true;
    try {
      const res = await Axios.get<CreditcardResponse>(this.creditcardApiUrl);
      this.creditcard = res.data.creditcard;
    } catch (error) {
      this.$router.push({ name: 'Top' });
    }
    this.loading = false;
  }

  private async onAdd() {
    const form: CreditcardEdit = {
      isEdit: false,
      cardSeq: -1,
      number: '',
      expireMonth: '',
      expireYear: '',
      holdername: '',
      securitycode: '',
      token: null,
    };

    let result: CreditcardEdit;
    try {
      result = await (this.$refs.cardEdit as DialogWrapper).open({...form}) as CreditcardEdit;
    } catch (error) {
      return;
    }

    const token = result.token;

    if (!token) {
      return;
    }

    this.loading = true;

    try {
      await Axios.post(this.creditcardApiUrl, {
        token,
      }, {
        dontDisplayErrorPage: true,
      });
      this.$notify.success({
        title: 'クレジットカード登録',
        message: 'クレジットカード情報を登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード登録',
        message: 'クレジットカード情報の登録が失敗しました。',
        position: 'bottom-right'
      });
    }

    this.loadData();
  }

  private async onEdit() {
    if (!this.creditcard) {
      return;
    }

    const form: CreditcardEdit = {
      isEdit: true,
      cardSeq: this.creditcard.cardSeq,
      number: this.creditcard.number,
      expireMonth: this.creditcard.expireMonth,
      expireYear: this.creditcard.expireYear,
      holdername: this.creditcard.holdername,
      securitycode: '',
      token: null,
    };

    let result: CreditcardEdit;
    try {
      result = await (this.$refs.cardEdit as DialogWrapper).open({...form}) as CreditcardEdit;
    } catch (error) {
      return;
    }

    const token = result.token;

    if (!token) {
      return;
    }

    this.loading = true;

    try {
      await Axios.put(this.creditcardApiUrl, {
        token,
      }, {
        dontDisplayErrorPage: true,
      });
      this.$notify.success({
        title: 'クレジットカード変更',
        message: 'クレジットカード情報を変更しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード変更',
        message: 'クレジットカード情報の変更が失敗しました。',
        position: 'bottom-right'
      });
    }

    this.loadData();
  }

  private async onDelete() {
    try {
      await this.$confirm('クレジットカードを削除します。よろしいですか？', 'クレジットカード削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });
    } catch (error) {
      return;
    }

    this.loading = true;

    try {
      await Axios.delete(this.creditcardApiUrl, {
        dontDisplayErrorPage: true,
      });
      this.$notify.success({
        title: 'クレジットカード削除',
        message: 'クレジットカード情報を削除しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード削除',
        message: 'クレジットカード情報の削除が失敗しました。',
        position: 'bottom-right'
      });
    }

    this.loadData();
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate(async (valid) => {
      if (valid) {
        const dialogWrapper = this.$refs.cardEdit as DialogWrapper;
        const form = dialogWrapper.form as CreditcardEdit;
        const dummyCreditcardNumber = (this as any).dummyCreditcardNumber;
        const dummyCreditcardSecurityCode = (this as any).dummyCreditcardSecurityCode;
        if (dummyCreditcardNumber) {
          if (form.number !== dummyCreditcardNumber) {
            this.$notify.error({
              title: 'クレジットカード登録',
              message: '検証環境の為、特定のカード情報のみ登録可能です。',
              position: 'bottom-right'
            });
            return false;
          }
        }
        if (dummyCreditcardSecurityCode) {
          if (form.securitycode !== dummyCreditcardSecurityCode) {
            this.$notify.error({
              title: 'クレジットカード登録',
              message: '検証環境の為、特定のカード情報のみ登録可能です。',
              position: 'bottom-right'
            });
            return false;
          }
        }

        const token = await this.getToken(
          form.number,
          form.expireYear,
          form.expireMonth,
          form.securitycode,
          form.holdername!
        );
        form.token = token;

        if (!token) {
          this.$notify.error({
            title: 'クレジットカード登録',
            message: 'クレジットカード登録処理中にエラーが発生しました。クレジットカード情報の入力をお確かめください。',
            position: 'bottom-right'
          });
          return false;
        }

        (this.$refs.cardEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async getToken(
    cardno: string,
    expireYear: string,
    expireMonth: string,
    securitycode: string,
    holdername: string
  ): Promise<string | null> {
    return await new Promise<string | null>((resolve) => {
      (window as any).Multipayment.init(this.tokenKey);

      (window as any).Multipayment.getToken(
        {
            cardno,
            expire: expireYear + expireMonth,
            securitycode,
            holdername,
            tokennumber: 1
        }, (result: any) => {
          if (result.resultCode !== '000') {
            resolve(null);
          } else {
            resolve(result.tokenObject.token[0]);
          }
        }
      );
    });
  }
}
